import { createFileRoute } from '@tanstack/react-router';
import { NewPasswordView } from '@/modules/auth';
import { PageMetadata } from '@/app/PageMetadata';
import { first } from '@/app/searchSerialization';

export const Route = createFileRoute('/new-password')({
  // Password-recovery emails link here with the reset email + code in the URL.
  validateSearch: (search: Record<string, unknown>): { email?: string; code?: string } => ({
    email: first(search.email),
    code: first(search.code),
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { email, code } = Route.useSearch();

  return (
    <>
      <PageMetadata title="Create New Password | Self Inspection" />
      <NewPasswordView email={email ?? null} code={code ?? null} />
    </>
  );
}
